<template>
  <div class="about van-hairline--top">
    <h1 @click="showToast">This is an about page</h1>
  </div>
</template>
<script>
  export default {
    methods: {
      showToast(){
        this.$router.push({
          path: '/login/success'
        })
      }
    },
  }
</script>
